export default "__VITE_ASSET__UtB2NKV2__"